const COMMON_SUFFIXES = ["3", "3B"];
const PREFERRED_SUFFIXES = ["4", "5", "6", "7", "8", "4B", "5B", "6B", "7B", "8B"];
const UNIT_SUFFIXES = ["11", "11B"];
const SPONSORED_BDR_SUFFIXES = ["32", "33"];
const UNSPONSORED_BDR_SUFFIXES = ["34", "35"];

export default class TickerSymbol {
  public static isPreferredStockSymbol(tickerSymbol: string) {
    if (tickerSymbol.length < 5) {
      return false;
    }
    const tickerSymbolSuffix = tickerSymbol.substring(4, tickerSymbol.length);
    return PREFERRED_SUFFIXES.some((suffix) => tickerSymbolSuffix === suffix);
  }

  public static isCommonStockSymbol(tickerSymbol: string) {
    if (tickerSymbol.length < 5) {
      return false;
    }
    const tickerSymbolSuffix = tickerSymbol.substring(4, tickerSymbol.length);
    return COMMON_SUFFIXES.some((suffix) => tickerSymbolSuffix === suffix);
  }

  public static isUnitStockSymbol(tickerSymbol: string) {
    if (tickerSymbol.length < 5) {
      return false;
    }
    const tickerSymbolSuffix = tickerSymbol.substring(4, tickerSymbol.length);
    return UNIT_SUFFIXES.some((suffix) => tickerSymbolSuffix === suffix);
  }

  public static isBrazilianDepositaryReceiptSymbol(tickerSymbol: string) {
    const tickerSymbolSuffix = tickerSymbol.substring(4, tickerSymbol.length);
    return [...SPONSORED_BDR_SUFFIXES, ...UNSPONSORED_BDR_SUFFIXES].some((suffix) => {
      return tickerSymbolSuffix === suffix;
    });
  }

  public static sort(aTickerSymbol: string, bTickerSymbol: string) {
    if (aTickerSymbol.length < 5 || bTickerSymbol.length < 5) {
      return 0;
    }
    const aSuffix = parseInt(aTickerSymbol.substring(4, aTickerSymbol.length), 10);
    const bSuffix = parseInt(bTickerSymbol.substring(4, bTickerSymbol.length), 10);
    return aSuffix - bSuffix;
  }
}
